import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Pagenation from "widget/Pagenation";

import TStyle from "shared/style/tableStyle";
import useFetch from "shared/model/useFetch";
import DefaultButton from "shared/ui/DefaultButton";

/**
 * @Desc 사용자 매장이용권 보유현황 (New)
 * @Access 프렌차이즈 매니저, 매장(지점) 매니저
 * 
 * @Api 모든 유저의 매장이용권 현황
 * @Data 사용자계정 IDX, 사용자 이름, 사용자 닉네임, 사용자가 보유한 매장이용권 수량
 */
const MyFranchiseMemberTicketList = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const searchRef = useRef();

  const [fetchResult, fetchRequest] = useFetch();

  const onClickSearch = () => {
    const searchValue = searchRef.current?.value || "";

    setSearchParams({
        accountNameLike: searchValue,
      });
  };

  useEffect(() => {
    const accountNameLike = searchParams.get("accountNameLike") || "";
    fetchRequest(
      "GET",
      `/admin/store_ticket/user/ticket_status?page=${page}&accountNameLike=${
        accountNameLike || ""}`
    );
  }, [page]);

  return (
    <Style.Wrapper>
      <MainHeader>사용자 매장 이용권 보유현황</MainHeader>
      <Style.InputWrapper>
        <input
          placeholder={"사용자 이름에 포함되는 글자로 검색"}
          defaultValue={searchParams.get("accountNameLike") || ""}
          ref={searchRef}
        />
        <DefaultButton small fitWidth expandHeight clickEvent={onClickSearch}>
          검색
        </DefaultButton>
      </Style.InputWrapper>

      <Style.AreaDiv>
        <TStyle.TableDiv>
          <TStyle.TableRow $title>
            <TStyle.Data $title $size={"short"}>
              IDX
            </TStyle.Data>
            <TStyle.Data $title $size={"longlong"}>
              사용자 이름
            </TStyle.Data>
            <TStyle.Data $title $size={"expand"}>
              사용자 닉네임
            </TStyle.Data>
            <TStyle.Data $title $size={"long"}>
              보유 수량
            </TStyle.Data>
          </TStyle.TableRow>
          {fetchResult?.data?.items?.map((item) => (
            <TStyle.TableRow key={item.userId}>
              <TStyle.Data $size={"short"}>{item.userId}</TStyle.Data>
              <TStyle.Data $size={"longlong"}>{item.userName}</TStyle.Data>
              <TStyle.Data $size={"expand"}>{item.userNickName}</TStyle.Data>
              <TStyle.Data $size={"long"}>{item.count}</TStyle.Data>
            </TStyle.TableRow>
          ))}
        </TStyle.TableDiv>
        <Pagenation maxPage={fetchResult?.data?.max_page} />
      </Style.AreaDiv>
    </Style.Wrapper>
  );
};

export default MyFranchiseMemberTicketList;
